import Store from '@/store/main/store';
import '../styles/globals.css';
import { Outlet, useHref, useNavigate } from 'react-router';

import { toast, Toaster } from 'sonner';
import { AuthProvider, SSO_LOGOUT_URL } from '@panamod/react-utils'
import { API_URL, SSO_API_URL, SSO_SITE_URL, SSO_ORIGIN } from '@/constants';
import { HeroUIProvider, Spinner } from '@heroui/react';
import { useEffect } from 'react';
import { simpleFetch } from '@/utils/simpleFetch';
import { checkVersionApiCompact } from '@panamod/general-utils';

interface FetchVersion {
	version: string
}

export const Root = () => {
    const navigate = useNavigate();

    const ChecarVersion = async () => {
        const response = await simpleFetch<FetchVersion>({
				url: `${API_URL}Obten/Version`,
				method: 'GET',
			});
			if(!response.success){
				throw response.data
			}
            
			console.log('Version response:', response.data);

			const hasChange = checkVersionApiCompact({currentApiVersion: response.data.version, localStorageKey: 'ENC_GP', hasLogs: true});

			console.log(hasChange);

			if(hasChange){
				toast.info('La versión de la aplicación ha cambiado, recargando...', { duration: 5000, icon: <Spinner /> });
				setTimeout(() => {
					window.location.reload();
				}, 2000);
			}
    }

    useEffect(() => {
        ChecarVersion();
    }, [])

    return (
        <HeroUIProvider navigate={navigate} useHref={useHref}>
            <Toaster position='top-right' richColors />
            <Store>
                <AuthProvider SSO_API_URL={SSO_API_URL} SSO_ORIGIN={SSO_ORIGIN} SSO_SITE_URL={SSO_SITE_URL} SSO_LOGOUT_URL={SSO_LOGOUT_URL} hasLogs={import.meta.env.DEV}>
                    <Outlet />
                </AuthProvider>
            </Store>
        </HeroUIProvider>
    );
}
